export const INCREMENT_REQUEST = "INCREMENT_REQUEST";
export const DECREMENT_REQUEST = "DECREMENT_REQUEST";
export const ERROR_SET = "ERROR_SET";

export const GOOGLE_USER_CHANGED = "GOOGLE_USER_CHANGED";
export const GOOGLE_AUTH_INITIALIZED = "GOOGLE_AUTH_INITIALIZED";

export const USER_AUTH_INITIALIZED = "USER_AUTH_INITIALIZED";

export const CUSTOMER_SET = "CUSTOMER_SET";

export const GROUP_SET = "GROUP_SET";
export const GROUPS_SET = "GROUPS_SET";

export const SIGN_OUT = "SIGN_OUT";
export const USER_SIGN_OUT = "USER_SIGN_OUT";
